<template>
  <div>
    <div v-if="this.$equipment !== null">
      <H5Home></H5Home>
    </div>
    <div v-else>
      <PcHome></PcHome>
    </div>
  </div>
</template>
<script>
import PcHome from "@/views/PcHome";
import H5Home from "@/views/H5Home";
export default {
  components: {PcHome,H5Home}
}
</script>
